import { styled } from '@mui/material/styles';
import { Dialog, Grid } from '@mui/material';

// Root container with flex display
export const RootContainer = styled('div')(() => ({
  display: "flex",
}));

// Toolbar spacer
export const ToolbarSpacer = styled('div')(({ theme }) => ({
  ...theme.mixins.toolbar,
}));

// Styled modal with centered content
export const StyledModal = styled(Dialog)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

// Main content area with padding
export const ContentContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(2),
  width: '100%',
}));

// Table container with overflow handling
export const TableContainer = styled(Grid)(() => ({
  width: '100%',
  overflowX: 'auto',
}));

// Action button with left margin
export const ActionButton = styled('button')(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

// New manager button with primary color
export const NewManagerButton = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
})); 